var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7153 0C14.6738 1.06399 13.5411 2.03554 12.3301 2.9036C8.74444 5.50035 4.31105 7.50641 0.486516 8.01655C-0.0394789 19.9397 3.47678 28.1308 9.72128 33.7635C11.5343 33.0577 13.542 31.9588 15.7249 30.5032C9.98332 26.7998 6.44394 21.3359 6.44394 13.0509C9.83111 12.4333 12.9119 10.9412 15.7249 9.0541C17.6739 7.64722 19.4401 6.00517 20.983 4.16554C19.0622 2.99712 17.2931 1.59812 15.7153 0Z",
    fill: "#FF3E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.948 8.02048C27.767 7.5928 24.1601 6.13525 20.9733 4.15796C19.4305 5.99759 17.6643 7.63965 15.7153 9.04652C18.5226 10.9413 21.6034 12.4257 24.9906 13.0433C24.9906 21.3341 21.4512 26.798 15.7153 30.4956C13.5324 31.957 11.5247 33.0559 9.71167 33.7559C11.5433 35.3945 13.5577 36.8185 15.7153 38.0001C16.6877 37.4593 17.6221 36.8839 18.5187 36.274C26.7285 30.6567 31.5607 21.8481 30.948 8.02048Z",
    fill: "#F67C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 20.5813L14.8913 23.3563L20.9235 15.9563",
    stroke: "#F67C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5652,
    height: 38,
    fill: "white",
    transform: "translate(0.434814)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.5bd8d1283db60f25d4842dc61b895b8c.svg";
export { ForwardRef as ReactComponent };